import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AppProvider } from './contexts/AppContext';
import PassIssuer from './pages/PassIssuer';
import ErrorBoundary from './components/ErrorBoundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <Router>
            <div className="h-screen-safe w-screen-safe bg-gray-50 no-overflow-x">
              <Routes>
                <Route path="/:brandId" element={<PassIssuer />} />
                <Route path="/:brandId/:userId" element={<PassIssuer />} />
                <Route path="/" element={<PassIssuer />} />
              </Routes>
            </div>
          </Router>
        </AppProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
